import React from 'react'
import styled from 'styled-components';

import { Link } from 'react-router-dom';


import {
    blank_box
} from '../../assets'

const PostCard = ({popular}) => {
        // console.log(popular.resourceNlnCode);

  return (

                    <BoxContainer  key={popular?.resourceId} >
                           

                           <LinkToDetails to={`/nigeriana/resource/${popular.resourceNlnCode}`} >
                           
                                <ImageContainer src={popular?.resourceImage} />
                                <TextContainer>
                                    <h5>
                                    {popular?.resourceTitle?.substring(0, 40) + ''}
                                    </h5>
                                    <small>by {popular?.resourceAuthor}</small>
                                </TextContainer>
                           </LinkToDetails>
                     </BoxContainer>




    // <BoxContainer>
    //     <ImageContainer src={blank_box} />
    //     <TextContainer>
    //         <h5>
    //         Dictionary of the Hausa language
    //         </h5>
    //         <small>
    //         by Robinson, Charles H 
    //         </small>
    //     </TextContainer>
    // </BoxContainer>
  )
};

export const BoxContainer = styled.div`
    width: 200px;
    /* width: 254px; */
    display: flex;
    padding-top: 10px;
    flex-direction: column;
    cursor: pointer;

    @media screen and (max-width: 600px){
        width: 300px;
    }
`

const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`

export const ImageContainer = styled.img`
    width: 200px;
    height: 254px;
    object-fit: fill;
    border-radius: 4px 4px 0px 0px;

    @media screen and (max-width: 600px){
        width: 300px;
    }

    :hover{
        opacity: 0.8;
        transition: 0.5s;
    }
`
export const TextContainer =  styled.div`
    padding: 10px 20px;
    width: 100%;
    text-align: left;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 4px 4px;

    & > h5{
        width: 100%;
        /* font-size: 14px; */
    }

`




export {PostCard}